import { Component, h, Prop, Element } from '@stencil/core';
import { getClassListString } from '../../component-utils/stencilUtils';

/**
 * COMPNAME is for displaying a heading for a section in a journal issue's table of contents.
 */
@Component({
  tag: 'aafp-journal-issue-toc-section-heading',
  shadow: false,
})
export class AafpJournalIssueTocSectionHeading {
  /**
   * For the specific journal (used for its brand color)
   */
  @Prop() journal!: 'afp' | 'fpm' | 'fpe';

  @Element() element: HTMLElement;

  render() {
    return (
      <h2
        class={getClassListString(
          { [`adl-journal-issue-toc-section-heading--${this.journal}`]: true },
          'adl-journal-issue-toc-section-heading',
        )}
      >
        <slot />
      </h2>
    );
  }
}
